export const NEW_SALE_DEFAULT_PATHS = [
  "/ventas/nueva",
  "/ventas/nueva-factura",
] as const;

export type NewSaleDefaultPath = (typeof NEW_SALE_DEFAULT_PATHS)[number];

export const DEFAULT_NEW_SALE_PATH: NewSaleDefaultPath = "/ventas/nueva";

export function resolveNewSaleDefaultPath(value: unknown): NewSaleDefaultPath {
  if (value === "/ventas/nueva-factura") {
    return "/ventas/nueva-factura";
  }
  return DEFAULT_NEW_SALE_PATH;
}

export function getDefaultNewSalePathFromOrganizationSettings(
  settings: unknown
): NewSaleDefaultPath {
  if (!settings || typeof settings !== "object") {
    return DEFAULT_NEW_SALE_PATH;
  }

  const salesSettings = (
    settings as { sales?: { defaultNewSalePath?: unknown } }
  ).sales;

  return resolveNewSaleDefaultPath(salesSettings?.defaultNewSalePath);
}
